import { makeAutoObservable } from 'mobx';
import { IUserInfo, userApi } from '@/axios/user';
import rum from '@/plugins/rum';

export const USER_TOKEN = 'DOUYIN_AI_USER_INFO';

class User {
  constructor() {
    makeAutoObservable(this);
  }
  info: IUserInfo | null = null;
  setUserInfo(info: Partial<IUserInfo> | null) {
    if (!info) {
      window.localStorage.removeItem(USER_TOKEN);
      this.info = null;
    } else {
      const data = { ...this.info, ...info };
      window.localStorage.setItem(USER_TOKEN, JSON.stringify(data));
      this.info = data as IUserInfo;
      rum.setUser?.(this.info.email + this.info.nickname)
    }
  }

  init = async () => {
    const localInfo = window.localStorage.getItem(USER_TOKEN);
    console.log('==>localInfo', localInfo);
    if (localInfo) {
      this.info = JSON.parse(localInfo);
      return userApi
        .getUserInfo()
        .then((data) => {
          data && this.setUserInfo(data);
        })
        .catch((err) => {});
    } else {
      return Promise.resolve();
    }
  };
}

export default new User();
